namespace RioERP.Masters {
    export interface StatesRow {
        Id?: number;
        Name?: string;
        IsActive?: boolean;
        IsHomeState?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace StatesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Masters.States';
        export const lookupKey = 'Masters.States';

        export function getLookup(): Q.Lookup<StatesRow> {
            return Q.getLookup<StatesRow>('Masters.States');
        }
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            IsActive = "IsActive",
            IsHomeState = "IsHomeState",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
